const RequestState = {
    Active: 'wpis na listę czynnych instruktorów',
    Reserve: 'przeniesienie do rezerwy',
    Vacations: 'urlop',
    Exit: 'wystąpienie z ZHR'
};

export default RequestState;